module.exports = __webpack_public_path__ + "img/file-searching-llm.0c41b7e3.svg";